import * as React from "react"
const SvgQuote = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m17.45 7.643-1.45 2.5q1.65 0 2.825 1.175T20 14.143c0 1.65-.392 2.041-1.175 2.825Q17.65 18.143 16 18.143c-1.65 0-2.042-.392-2.825-1.175Q12 15.793 12 14.143q0-.575.137-1.063a3.7 3.7 0 0 1 .413-.937l3.175-5.5a.97.97 0 0 1 .85-.5q.574 0 .863.5a.96.96 0 0 1 .012 1m-9 0L7 10.143q1.65 0 2.825 1.175T11 14.143c0 1.65-.392 2.041-1.175 2.825Q8.65 18.142 7 18.143c-1.65.001-2.042-.392-2.825-1.175Q3 15.793 3 14.143q0-.575.138-1.063.137-.487.412-.937l3.175-5.5a.97.97 0 0 1 .85-.5q.574 0 .862.5a.96.96 0 0 1 .013 1m7.55 5q-.624 0-1.063.437a1.45 1.45 0 0 0-.437 1.063q0 .625.438 1.062.437.438 1.062.438t1.063-.438q.437-.437.437-1.062t-.438-1.063A1.45 1.45 0 0 0 16 12.643m-9 0q-.624 0-1.063.437a1.45 1.45 0 0 0-.437 1.063q0 .625.438 1.062.437.438 1.062.438.624 0 1.063-.438.437-.437.437-1.062t-.438-1.063A1.45 1.45 0 0 0 7 12.643" />
  </svg>
)
export default SvgQuote
